import { useCallback } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { EducationHostedFormSteps } from '../EducationHostedForm.types'

export const useNavigateForm = () => {
  const navigate = useNavigate()
  const { programId } = useParams<{ programId: string }>()
  const [searchParams] = useSearchParams()
  const jwtToken = searchParams.get('token')

  const handleNextStep = useCallback(
    (formStep: EducationHostedFormSteps) => {
      navigate(`/validate/${programId}?token=${jwtToken}&pageId=${formStep}`)
    },
    [navigate, programId, jwtToken]
  )

  const handlePreviousStep = useCallback(() => navigate(-1), [navigate])

  return { handleNextStep, handlePreviousStep }
}
